import DramaCard from '@/components/base/DramaCard';
import type { Drama } from '@/mocks/dramas';

interface HotDramasProps {
  dramas: Drama[];
}

export default function HotDramas({ dramas }: HotDramasProps) {
  return (
    <section className="py-10 md:py-14">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">
              大家都在追的爆款好剧
            </p>
          </div>
          <a
            href="/category/hot"
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: 'smooth' });
              window.location.href = '/category/hot';
            }}
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line text-sm"></i>
          </a>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-3 md:gap-5">
          {dramas.filter((d) => d.isHot).map((drama) => (
            <DramaCard key={drama.id} drama={drama} />
          ))}
        </div>
      </div>
    </section>
  );
}